import './../../care-plan/activities-group-entry-configuration-value/activities-group-entry-configuration-value.scss';
import {CarePlanConfiguration} from '../../../backend/interfaces/care-plan-configuration';
import {CarePlanConfigurationType} from '../../../backend/enums/care-plan-configuration-type';
import {CarePlanConfigurationFeature} from '../../../backend/enums/care-plan-configuration-feature';
import {useTranslation} from 'react-i18next';
import {scheduleReadableExpression} from '../../../utils/functions';
import {ArrayField} from '../../care-plan/activities-group-entry-configuration-value/activities-group-entry-configuration-value';

type TemporaryConfigurationOverride = Omit<CarePlanConfiguration, 'type'> & {
  type: CarePlanConfigurationType | CarePlanConfigurationFeature;
};

interface CarePlanSheetActivitiesGroupEntryConfigurationValueProps {
  configuration: TemporaryConfigurationOverride;
  value: string | string[];
}

export const TaskCardValue = ({
  configuration,
  value,
}: CarePlanSheetActivitiesGroupEntryConfigurationValueProps) => {
  const {t} = useTranslation();

  if (!configuration || !value || (Array.isArray(value) && value.length === 0)) return null;

  return (
    <>
      <label className="title">{configuration?.name}</label>

      <>
        {configuration.type === CarePlanConfigurationType.String && (
          <div className="value">{value}</div>
        )}

        {configuration.type === CarePlanConfigurationFeature.Schedule && (
          <div className="value">{value}</div>
        )}

        {(configuration.type === CarePlanConfigurationType.ActivityTypeSchedule ||
          configuration.type === CarePlanConfigurationType.ActivitiesGroupSchedule) && (
          <div className="value">
            {scheduleReadableExpression({
              t,
              scheduleDefinition: JSON.parse(String(value)),
            })}
          </div>
        )}

        {configuration.type === CarePlanConfigurationType.Array && (
          <ArrayField {...{configuration, value, onEditMode: false, renderAsText: true}} />
        )}

        {configuration.type === CarePlanConfigurationType.Number && (
          <div className="value">{value}</div>
        )}
      </>
    </>
  );
};
